import {
  useListAccomodationsQuery,
  useListActiveAccomodationsQuery,
} from "../store/accomodation/accomodation";
import { Conference } from "../types/conference.types";
import { Accomodation } from "../types/accomodation.types";

interface UseAccomodationsQueryResult {
  accomodations: Accomodation[];
  isLoadingAccomodations: boolean;
}

export const useAccomodationsQuery = (
  congressId: number,
  isEditMode: boolean,
  congressEvent: Conference | null
): UseAccomodationsQueryResult => {
  const shouldFetchAccomodations =
    !!congressEvent &&
    !!congressEvent.configJson.accommodationEnabled &&
    !!congressId;

  const accomodationsPublicQuery = useListActiveAccomodationsQuery(congressId, {
    skip: isEditMode || !shouldFetchAccomodations,
  });
  const accomodationsHiddenQuery = useListAccomodationsQuery(congressId, {
    skip: !isEditMode || !shouldFetchAccomodations,
  });

  const accomodations = isEditMode
    ? accomodationsHiddenQuery.data ?? []
    : accomodationsPublicQuery.data ?? [];
  const isLoadingAccomodations = isEditMode
    ? accomodationsHiddenQuery.isLoading
    : accomodationsPublicQuery.isLoading;

  return {
    accomodations,
    isLoadingAccomodations,
  };
};
